import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '../../mui/Components/Typography';
import Form from '../../form/components/Form';
import RadioInput from '../../form/components/RadioInput';
import SubmitButton from '../../form/components/SubmitButton';
import { IdPropType } from '../../../proptypes/basic';
import { formatDate } from '../../../helpers/tools';
import { selectCustomerById, updateCustomer } from '../customersSlice';
import { CUSTOMER_RESOURCE } from '../../api/resources';
import { HOLIDAY_CARE_FIELDS } from '../holidayCare';

const OPTIONS = [
    { value: 'yes', label: 'Ja' },
    { value: 'no', label: 'Nein' },
];

const toFormValue = (value) => {
    if (value === null || value === undefined) {
        return '';
    }
    return value ? 'yes' : 'no';
};

const fromFormValue = (value) => {
    if (value === '') {
        return null;
    }
    return value === 'yes';
};

/**
 * #1035 Osterbetreuung / Weihnachts- und/oder Neujahrsbetreuung im BK-Verlauf
 */
const HolidayCareForm = ({ customerId, disabled }) => {
    const customer = useSelector((state) => selectCustomerById(state, customerId));
    const dispatch = useDispatch();

    const initialValues = useMemo(
        () =>
            HOLIDAY_CARE_FIELDS.reduce(
                (values, { field }) => ({
                    ...values,
                    [field]: toFormValue(customer && customer[field]),
                }),
                {}
            ),
        [customer]
    );

    const handleSubmit = useCallback(
        (values) =>
            dispatch(
                updateCustomer(
                    HOLIDAY_CARE_FIELDS.reduce(
                        (prepped, { field }) => ({
                            ...prepped,
                            [field]: fromFormValue(values[field]),
                        }),
                        { id: customerId }
                    )
                )
            ),
        [dispatch, customerId]
    );

    return (
        <Form
            initialValues={initialValues}
            onSubmit={handleSubmit}
            subject={customer || CUSTOMER_RESOURCE}
        >
            <Grid container spacing={1}>
                {HOLIDAY_CARE_FIELDS.map(({ field, label }) => (
                    <Grid item xs={12} key={field}>
                        <RadioInput
                            name={field}
                            label={label}
                            options={OPTIONS}
                            empty="offen"
                            horizontal
                            disabled={disabled}
                        />
                        {customer && customer[`${field}At`] && (
                            <Typography variant="caption" color="textSecondary" component="div">
                                eingetragen am {formatDate(customer[`${field}At`])}
                            </Typography>
                        )}
                    </Grid>
                ))}
                <Grid item xs={12}>
                    <Box textAlign="right">
                        <SubmitButton disabled={disabled} />
                    </Box>
                </Grid>
            </Grid>
        </Form>
    );
};

HolidayCareForm.propTypes = {
    customerId: IdPropType.isRequired,
    disabled: PropTypes.bool,
};

HolidayCareForm.defaultProps = {
    disabled: false,
};

export default HolidayCareForm;
